import cat1 from '../images/gallerium/category/InvitedPresentations.png'
import cat2 from '../images/gallerium/category/SateliteSymposium.png'
import cat3 from '../images/gallerium/category/VirtualProductTheatre.png'
import slide1 from '../images/gallerium/vod/vod1.png'
import slide2 from '../images/gallerium/vod/vod2.png'
import slide3 from '../images/gallerium/vod/vod3.png'
import slide4 from '../images/gallerium/vod/vod4.png'
import slide5 from '../images/gallerium/vod/vod5.png'
import slide6 from '../images/gallerium/vod/vod6.png'
import slide7 from '../images/gallerium/vod/vod7.png'
import slide8 from '../images/gallerium/vod/vod8.png'
import slide9 from '../images/gallerium/vod/vod9.png'
import slide10 from '../images/gallerium/vod/vod10.png'
import slide11 from '../images/gallerium/vod/vod11.png'
import slide12 from '../images/gallerium/vod/vod12.png'
import slide13 from '../images/gallerium/vod/vod13.png'
import slide14 from '../images/gallerium/vod/vod14.png'
import slide15 from '../images/gallerium/vod/vod15.png'
import slide16 from '../images/gallerium/vod/vod16.png'
import slide17 from '../images/gallerium/vod/vod17.png'
import slide18 from '../images/gallerium/vod/vod18.png'
import slide19 from '../images/gallerium/vod/vod19.png'
import slide20 from '../images/gallerium/vod/vod20.png'
import slide21 from '../images/gallerium/vod/vod21.png'
import slide22 from '../images/gallerium/vod/vod22.png'
import slide23 from '../images/gallerium/vod/vod23.png'
import slide24 from '../images/gallerium/vod/vod24.png'
import slide25 from '../images/gallerium/vod/vod25.png'
import slide26 from '../images/gallerium/vod/vod26.png'
import slide27 from '../images/gallerium/vod/vod27.png'
import slide28 from '../images/gallerium/vod/vod28.png'
import slide29 from '../images/gallerium/vod/vod29.png'
import slide30 from '../images/gallerium/vod/vod30.png'
import slide31 from '../images/gallerium/vod/vod31.png'
import slide32 from '../images/gallerium/vod/vod32.png'
import slide33 from '../images/gallerium/vod/vod33.png'
import slide34 from '../images/gallerium/vod/vod34.png'
import slide35 from '../images/gallerium/vod/vod35.png'
import slide36 from '../images/gallerium/vod/vod36.png'
import slide37 from '../images/gallerium/vod/vod37.png'
import slide38 from '../images/gallerium/vod/vod38.png'
import slide39 from '../images/gallerium/vod/vod39.png'
import slide40 from '../images/gallerium/vod/vod40.png'
import slide41 from '../images/gallerium/vod/vod41.png'
import slide42 from '../images/gallerium/vod/vod42.png'
import slide43 from '../images/gallerium/vod/vod43.png'
import slide44 from '../images/gallerium/vod/vod44.png'
import slide45 from '../images/gallerium/vod/vod45.png'
import slide46 from '../images/gallerium/vod/vod46.png'
import slide47 from '../images/gallerium/vod/vod47.png'
import slide48 from '../images/gallerium/vod/vod48.png'
import slide49 from '../images/gallerium/vod/vod49.png'
import satelite1 from '../images/gallerium/vod/satelite1.png'
import satelite2 from '../images/gallerium/vod/satelite2.png'
import satelite3 from '../images/gallerium/vod/satelite3.png'
import satelite4 from '../images/gallerium/vod/satelite4.png'
import virtual1 from '../images/gallerium/vod/virtual1.png'
import virtual2 from '../images/gallerium/vod/virtual2.png'
import virtual3 from '../images/gallerium/vod/virtual3.png'
import virtual4 from '../images/gallerium/vod/virtual4.png'
import master1 from '../images/gallerium/masterclass/master1.png'
import master2 from '../images/gallerium/masterclass/master2.png'
import master3 from '../images/gallerium/masterclass/master3.png'
import master4 from '../images/gallerium/masterclass/master4.png'
import master5 from '../images/gallerium/masterclass/master5.png'
import master6 from '../images/gallerium/masterclass/master6.png'
import master7 from '../images/gallerium/masterclass/master7.png'
import master8 from '../images/gallerium/masterclass/master8.png'
import master9 from '../images/gallerium/masterclass/master9.png'
import master10 from '../images/gallerium/masterclass/master10.png'
import master11 from '../images/gallerium/masterclass/master11.png'
import master12 from '../images/gallerium/masterclass/master12.png'
import master13 from '../images/gallerium/masterclass/master13.png'
import master14 from '../images/gallerium/masterclass/master14.png'
import master15 from '../images/gallerium/masterclass/master15.png'
import master16 from '../images/gallerium/masterclass/master16.png'
import master17 from '../images/gallerium/masterclass/master17.png'

const onDemand = [
  {
    name: "Invited Presentations",
    thumbnail: cat1,
    destination: "/on-demand/invited-presentations",
    videos: [
      {
        id: 'A1',
        category: "NEURO-ONCOLOGY",
        topic: "Fluorescence guided resections for brain tumors: What you see …and What you Don’t!",
        speaker: "Dr Aliasgar Moiyadi",
        country: "India",
        link: "https://player.vimeo.com/video/558478884",
        form: "aliasgar.moiyadi@gmail.com",
        thumbnail: slide1,
        title: "NEURO-ONCOLOGY Fluorescence guided resections for brain tumors: What you see …and What you Don’t! Dr Aliasgar Moiyadi India",
      },
      {
        id: 'A2',
        category: "NEURO-ONCOLOGY",
        topic: "A Surgical Randomised-Controlled Trial(RCT) for Diffuse Low Grade Glioma (DLGG) : Is It Necessary?",
        speaker: "Assoc Prof Dr Farizal Fadzil",
        country: "Malaysia",
        link: "https://player.vimeo.com/video/557292276",
        form: "nurelisha@yahoo.com",
        thumbnail: slide2,
        title: "NEURO-ONCOLOGY A Surgical Randomised-Controlled Trial(RCT) for Diffuse Low Grade Glioma (DLGG) : Is It Necessary? Assoc Prof Dr Farizal Fadzil Malaysia",
      },
      {
        id: 'A3',
        category: "NEURO-ONCOLOGY",
        topic: "Management of Meningioma In The Modern Era",
        speaker: "Dr Sharon Casilda Theophilus",
        country: "Malaysia",
        link: "https://player.vimeo.com/video/558796174",
        form: "sc_theo3@yahoo.com",
        thumbnail: slide3,
        title: "NEURO-ONCOLOGY Management of Meningioma In The Modern Era Dr Sharon Casilda Theophilus Malaysia",
      },
      {
        id: 'A4',
        category: "NEURO-ONCOLOGY",
        topic: "Multidisciplinary Approach in Surgical Reconstruction of Facial Nerve Paralysis",
        speaker: "Dr Wuttipong Tirakotai",
        country: "Thailand",
        link: "https://player.vimeo.com/video/557405313",
        form: "tirakotai@gmail.com",
        thumbnail: slide4,
        title: "NEURO-ONCOLOGY Multidisciplinary Approach in Surgical Reconstruction of Facial Nerve Paralysis Dr Wuttipong Tirakotai Thailand",
      },
      // {
      //   id: 'A5',
      //   category: "NEURO-ONCOLOGY",
      //   topic: "PENDING",
      //   speaker: "Assoc Prof Dr Azizi Abu Bakar",
      //   country: "Malaysia",
      //   link: "",
      //   form: "abazizi@gmail.com",
      //   thumbnail: slide5,
      //   title: "NEURO-ONCOLOGY PENDING Assoc Prof Dr Azizi Abu Bakar Malaysia",
      // },
      {
        id: 'B1',
        category: "SPINE / PERIPHERAL NERVE",
        topic: "The Utility of TLIF: A Local Neurosurgical Perspective",
        speaker: "Dr Albert Wong Sii Hieng",
        country: "Malaysia",
        link: "https://player.vimeo.com/video/558574009",
        form: "wonghm96@yahoo.com",
        thumbnail: slide6,
        title: "SPINE / PERIPHERAL NERVE The Utility of TLIF: A Local Neurosurgical Perspective Dr Albert Wong Sii Hieng Malaysia",
      },
      {
        id: 'B2',
        category: "SPINE / PERIPHERAL NERVE",
        topic: "Brachial Plexus Injuries: Challenges in the Next Future",
        speaker: "Dr. Debora Garozzo",
        country: "UAE",
        link: "https://player.vimeo.com/video/557291867",
        form: "debora.garozzo@esns.ae",
        thumbnail: slide7,
        title: "SPINE / PERIPHERAL NERVE Brachial Plexus Injuries: Challenges in the Next Future Dr. Debora Garozzo UAE",
      },
      {
        id: 'B3',
        category: "SPINE / PERIPHERAL NERVE",
        topic: "Trends, insights, innovation as a game changer for update in brachial plexus and peripheral nerve surgery-myth or reality",
        speaker: "Dr Lukas Rasulic",
        country: "Serbia",
        link: "https://player.vimeo.com/video/557291951",
        form: "lukas.rasulic@gmail.com",
        thumbnail: slide8,
        title: "SPINE / PERIPHERAL NERVE Trends, insights, innovation as a game changer for update in brachial plexus and peripheral nerve surgery-myth or reality Dr Lukas Rasulic Serbia",
      },
      {
        id: 'C1',
        category: "TECHNOLOGICAL ADVANCMENTS IN NEUROSURGERY",
        topic: "Intra op use of C ARM AND O ARM",
        speaker: "Dr Manas Panigrahi",
        country: "India",
        link: "https://player.vimeo.com/video/557288771",
        form: "manasp1966@gmail.com",
        thumbnail: slide9,
        title: "TECHNOLOGICAL ADVANCMENTS IN NEUROSURGERY Intra op use of C ARM AND O ARM Dr Manas Panigrahi India",
      },
      {
        id: 'C2',
        category: "TECHNOLOGICAL ADVANCMENTS IN NEUROSURGERY",
        topic: "Intraoperative Imaging in Brain Tumor Surgery",
        speaker: "Prof Dr Llewellyn Padayachy",
        country: "South Africa",
        link: "https://player.vimeo.com/video/557288853",
        form: "lc.padayachy@up.ac.za",
        thumbnail: slide10,
        title: "TECHNOLOGICAL ADVANCMENTS IN NEUROSURGERY Intraoperative Imaging in Brain Tumor Surgery Prof Dr Llewellyn Padayachy South Africa",
      },
      {
        id: 'C3',
        category: "TECHNOLOGICAL ADVANCMENTS IN NEUROSURGERY",
        topic: "10 Lessons I’ve learned in a 40 years’ Experience!",
        speaker: "Prof Dr Christian Matula",
        country: "Vienna",
        link: "https://player.vimeo.com/video/558567088",
        form: "christian.matula@meduniwien.ac.at",
        thumbnail: slide11,
        title: "TECHNOLOGICAL ADVANCMENTS IN NEUROSURGERY 10 Lessons I’ve learned in a 40 years’ Experience! Prof Dr Christian Matula Vienna",
      },
      {
        id: 'D1',
        category: "SKULL BASE",
        topic: "Hemispheric Gliomas - Role Of Functional Mapping And Awake Surgery",
        speaker: "Dr Dilip Panikar",
        country: "India",
        link: "https://player.vimeo.com/video/557457160",
        form: "panikar.d@gmail.com",
        thumbnail: slide12,
        title: "SKULL BASE Hemispheric Gliomas - Role Of Functional Mapping And Awake Surgery Dr Dilip Panikar India",
      },
      {
        id: 'D2',
        category: "SKULL BASE",
        topic: "Endoscopic-assisted keyhole retro-sigmoid approach for the posterior fossa lesions",
        speaker: "Assoc Prof Dr Duong Dai Ha",
        country: "Vietnam",
        link: "https://player.vimeo.com/video/557285686",
        form: "duongdaiha@hmu.edu.vn",
        thumbnail: slide13,
        title: "SKULL BASE Endoscopic-assisted keyhole retro-sigmoid approach for the posterior fossa lesions Assoc Prof Dr Duong Dai Ha Vietnam",
      },
      {
        id: 'D3',
        category: "SKULL BASE",
        topic: "Modified Transpetrosal – Transtentorial Approach for Resection of Large and Giant Petroclival Meningioma: Technical Nuance and Surgical Experience",
        speaker: "Dr Irwan Barlian Immadoel Haq",
        country: "Indonesia",
        link: "https://player.vimeo.com/video/557405124",
        form: "immadoelhaq@gmail.com",
        thumbnail: slide14,
        title: "SKULL BASE Modified Transpetrosal – Transtentorial Approach for Resection of Large and Giant Petroclival Meningioma: Technical Nuance and Surgical Experience Dr Irwan Barlian Immadoel Haq Indonesia",
      },
      {
        id: 'D4',
        category: "SKULL BASE",
        topic: "Intraoperative MRI: King Chulalongkorn Neurosurgery Early Experience",
        speaker: "Assoc Prof Dr Rungsak Siwanuwatn",
        country: "Thailand",
        link: "https://player.vimeo.com/video/557285606",
        form: "rungsak@yahoo.com",
        thumbnail: slide15,
        title: "SKULL BASE Intraoperative MRI: King Chulalongkorn Neurosurgery Early Experience Assoc Prof Dr Rungsak Siwanuwatn Thailand",
      },
      {
        id: 'E1',
        category: "VASCULAR",
        topic: "Endovascular Treatment for Cerebral Vasospasm",
        speaker: "Asst Prof Atithep Mongkolratnan",
        country: "Thailand",
        link: "https://player.vimeo.com/video/557282806",
        form: "doc.thep@gmail.com",
        thumbnail: slide16,
        title: "VASCULAR Endovascular Treatment for Cerebral Vasospasm Asst Prof Atithep Mongkolratnan Thailand",
      },
      {
        id: 'E2',
        category: "VASCULAR",
        topic: "ABCs of AVM Surgery",
        speaker: "Dr Azman Raffiq",
        country: "Malaysia",
        link: "https://player.vimeo.com/video/557282050",
        form: "denshum77@yahoo.com",
        thumbnail: slide17,
        title: "VASCULAR ABCs of AVM Surgery Dr Azman Raffiq Malaysia",
      },
      {
        id: 'E3',
        category: "VASCULAR",
        topic: "Treatment strategy of the thrombosed large/giant vertebral artery aneurysms",
        speaker: "Prof Dr Takayuki Hara",
        country: "Japan",
        link: "https://player.vimeo.com/video/558023730",
        form: "takayuki_hara@syd.odn.ne.jp",
        thumbnail: slide18,
        title: "VASCULAR Treatment strategy of the thrombosed large/giant vertebral artery aneurysms Prof Dr Takayuki Hara Japan",
      },
      {
        id: 'F1',
        category: "PAEDIATRICS",
        topic: "The Surgery for Non-Syndromic Craniosynostosis in Children hospital 2, Southern Vietnam",
        speaker: "Dr Dang Do Thanh Can",
        country: "Vietnam",
        link: "https://player.vimeo.com/video/557278235",
        form: "drthanhcan@gmail.com",
        thumbnail: slide19,
        title: "PAEDIATRICS The Surgery for Non-Syndromic Craniosynostosis in Children hospital 2, Southern Vietnam Dr Dang Do Thanh Can Vietnam",
      },
      // {
      //   id: 'F2',
      //   category: "PAEDIATRICS",
      //   topic: "PENDING",
      //   speaker: "Dr Nujaimin Udin",
      //   country: "Malaysia",
      //   link: "",
      //   form: "",
      //   thumbnail: slide20,
      //   title: "PAEDIATRICS PENDING Dr Nujaimin Udin Malaysia",
      // },
      {
        id: 'F3',
        category: "PAEDIATRICS",
        topic: "Corpus Callosotomy in Catastrophic Pediatric Epilepsy",
        speaker: "Dr Nunthasiri Wittayanakorn",
        country: "Thailand",
        link: "https://player.vimeo.com/video/557277705",
        form: "nanthasiriw@gmail.com",
        thumbnail: slide21,
        title: "PAEDIATRICS Corpus Callosotomy in Catastrophic Pediatric Epilepsy Dr Nunthasiri Wittayanakorn Thailand",
      },
      {
        id: 'F4',
        category: "PAEDIATRICS",
        topic: "Endoscopic Treatment Of Hydrocephalus In Infants",
        speaker: "Assoc Prof Dr Ronnie E. Baticulon",
        country: "Philippines",
        link: "https://player.vimeo.com/video/557277792",
        form: "rebaticulon@up.edu.ph",
        thumbnail: slide22,
        title: "PAEDIATRICS Endoscopic Treatment Of Hydrocephalus In Infants Assoc Prof Dr Ronnie E. Baticulon Philippines",
      },
      {
        id: 'F5',
        category: "PAEDIATRICS",
        topic: "Updates in the Management of Pediatric Brain Tumor in the Molecular Era",
        speaker: "Assis Prof Dr Vincent Nga",
        country: "Singapore",
        link: "https://player.vimeo.com/video/557789145",
        form: "vincent_nga@nuhs.edu.sg",
        thumbnail: slide23,
        title: "PAEDIATRICS Updates in the Management of Pediatric Brain Tumor in the Molecular Era Assis Prof Dr Vincent Nga Singapore",
      },
      {
        id: 'F6',
        category: "PAEDIATRICS",
        topic: "Programmable Shut Valves In Children: Experience form A Singapore Children's Hospital",
        speaker: "Dr Sharon Low Yin Yee",
        country: "Singapore",
        link: "https://player.vimeo.com/video/558483416",
        form: "sharon.low.y.y@singhealth.com.sg",
        thumbnail: slide24,
        title: "PAEDIATRICS Programmable Shut Valves In Children: Experience form A Singapore Children's Hospital Dr Sharon Low Yin Yee Singapore",
      },
      {
        id: 'G1',
        category: "FUTURE OF EDUCATION AND PERSPECTIVE ON WORLD NEUROSURGERY",
        topic: "Competency-based Education in Neurosurgery and Canada’s Model",
        speaker: "Dr Janissardhar Skulsampaopol",
        country: "Thailand",
        link: "https://player.vimeo.com/video/557273799",
        form: "janissardhar.sku@mahidol.ac.th",
        thumbnail: slide25,
        title: "FUTURE OF EDUCATION AND PERSPECTIVE ON WORLD NEUROSURGERY Competency-based Education in Neurosurgery and Canada’s Model Dr Janissardhar Skulsampaopol Thailand",
      },
      {
        id: 'G2',
        category: "FUTURE OF EDUCATION AND PERSPECTIVE ON WORLD NEUROSURGERY",
        topic: "ASEAN Common Neurosurgical Education Syllabus And Multicenter Research Is The Way To Go",
        speaker: "Prof Dato' Dr Jafri Malin Abdullah",
        country: "Malaysia",
        link: "https://player.vimeo.com/video/557274073",
        form: "jafrimalin@usm.my",
        thumbnail: slide26,
        title: "FUTURE OF EDUCATION AND PERSPECTIVE ON WORLD NEUROSURGERY ASEAN Common Neurosurgical Education Syllabus And Multicenter Research Is The Way To Go Prof Dato' Dr Jafri Malin Abdullah Malaysia",
      },
      // {
      //   id: 'G3',
      //   category: "FUTURE OF EDUCATION AND PERSPECTIVE ON WORLD NEUROSURGERY",
      //   topic: "The Mystery of Uncommon Neurosurgical Lesions in Enugu",
      //   speaker: "Ohaegbulam Samuel",
      //   country: "Nigeria",
      //   link: "",
      //   form: "samcohaegbulam@hotmail.com",
      //   thumbnail: slide27,
      //   title: "FUTURE OF EDUCATION AND PERSPECTIVE ON WORLD NEUROSURGERY The Mystery of Uncommon Neurosurgical Lesions in Enugu Ohaegbulam Samuel Nigeria",
      // },
      {
        id: 'G4',
        category: "FUTURE OF EDUCATION AND PERSPECTIVE ON WORLD NEUROSURGERY",
        topic: "COVID 19 & Hemorrhagic Stroke Outcome (At The First Wave)",
        speaker: "Dr Kullapat Veerasarn",
        country: "Thailand",
        link: "https://player.vimeo.com/video/557273956",
        form: "kveerasarn@hotmail.com",
        thumbnail: slide28,
        title: "FUTURE OF EDUCATION AND PERSPECTIVE ON WORLD NEUROSURGERY COVID 19 & Hemorrhagic Stroke Outcome (At The First Wave) Dr Kullapat Veerasarn Thailand",
      },
      {
        id: 'G5',
        category: "FUTURE OF EDUCATION AND PERSPECTIVE ON WORLD NEUROSURGERY",
        topic: "Chronic Granulomatous Infection of the Seller Region (Trans-sphenoidal Approach)",
        speaker: "Prof Dr Kyi Hlaing",
        country: "Myanmar",
        link: "https://player.vimeo.com/video/557273726",
        form: "drkhlaing@gmail.com",
        thumbnail: slide29,
        title: "FUTURE OF EDUCATION AND PERSPECTIVE ON WORLD NEUROSURGERY Chronic Granulomatous Infection of the Seller Region (Trans-sphenoidal Approach) Prof Dr Kyi Hlaing Myanmar",
      },
      {
        id: 'H1',
        category: "TRAUMA",
        topic: "Microsurgery for Pineal Region Tumors",
        speaker: "Dr Dang Do Thanh Can",
        country: "Vietnam",
        link: "https://player.vimeo.com/video/557271470",
        form: "drthanhcan@gmail.com",
        thumbnail: slide30,
        title: "TRAUMA Microsurgery for Pineal Region Tumors Dr Dang Do Thanh Can Vietnam",
      },
      {
        id: 'H2',
        category: "TRAUMA",
        topic: "Task Sharing / Shifting Model: Addressing the Scarcity of Neurosurgeons in the Bicol Region of the Philippines",
        speaker: "Dr Lynne Lourdes N. Lucena",
        country: "Philippines",
        link: "https://player.vimeo.com/video/557359214",
        form: "lynne.lucena@gmail.com",
        thumbnail: slide31,
        title: "TRAUMA Task Sharing / Shifting Model: Addressing the Scarcity of Neurosurgeons in the Bicol Region of the Philippines Dr Lynne Lourdes N. Lucena Philippines",
      },
      {
        id: 'H3',
        category: "TRAUMA",
        topic: "Delayed Intracerebral Haemorrhage",
        speaker: "Dato Dr Nasser Abdul Wahab",
        country: "Malaysia",
        link: "https://player.vimeo.com/video/558501069",
        form: "nasserdr@msn.com",
        thumbnail: slide32,
        title: "TRAUMA Delayed Intracerebral Haemorrhage Dato Dr Nasser Abdul Wahab Malaysia",
      },
      {
        id: 'I1',
        category: "EPILEPSY",
        topic: "Initiating an Epilepsy Surgery Program with Limited Resources in Indonesia",
        speaker: "Dr Muhamad Thohar Arifin",
        country: "Indonesia",
        link: "https://player.vimeo.com/video/557268364",
        form: "thohar@gmail.com",
        thumbnail: slide33,
        title: "EPILEPSY Initiating an Epilepsy Surgery Program with Limited Resources in Indonesia Dr Muhamad Thohar Arifin Indonesia",
      },
      {
        id: 'I2',
        category: "EPILEPSY",
        topic: "Antero-Medial Temporal Lobectomy (AMTL) Tips For the Beginners",
        speaker: "Dr Saiful Azli Mat Nayan",
        country: "Malaysia",
        link: "https://player.vimeo.com/video/557268467",
        form: "mrsaifulazlihsb@gmail.com",
        thumbnail: slide34,
        title: "EPILEPSY Antero-Medial Temporal Lobectomy (AMTL) Tips For the Beginners Dr Saiful Azli Mat Nayan Malaysia",
      },
      {
        id: 'J1',
        category: "RADIOSURGERY",
        topic: "Deep Brain Stimulation (DBS) Movement Disorders-USM Experience (2007 -2020)",
        speaker: "Prof Dato' Dr Abdul Rahman Izaini Ghani",
        country: "Malaysia",
        link: "https://player.vimeo.com/video/558504097",
        form: "abrahmanghani@yahoo.com",
        thumbnail: slide35,
        title: "RADIOSURGERY Deep Brain Stimulation (DBS) Movement Disorders-USM Experience (2007 -2020) Prof Dato' Dr Abdul Rahman Izaini Ghani Malaysia",
      },
      {
        id: 'J2',
        category: "RADIOSURGERY",
        topic: "Outcomes of Vestibular Schwannoma Treated with Multisession Stereotactic Radiosurgery (SRS) at Ramathibodi Hospital",
        speaker: "Dr Wasawat Muninthorn",
        country: "Thailand",
        link: "https://player.vimeo.com/video/557265411",
        form: "mindsenberg@gmail.com",
        thumbnail: slide36,
        title: "RADIOSURGERY Outcomes of Vestibular Schwannoma Treated with Multisession Stereotactic Radiosurgery (SRS) at Ramathibodi Hospital Dr Wasawat Muninthorn Thailand",
      },
      {
        id: 'J3',
        category: "RADIOSURGERY",
        topic: "Gamma Knife Surgery for Trigeminal Neuralgia",
        speaker: "Dato' Dr Jagdeep Nanra",
        country: "Malaysia",
        link: "https://player.vimeo.com/video/558912368",
        form: "jagnanra@hotmail.com",
        thumbnail: slide49,
        title: "RADIOSURGERY Gamma Knife Surgery for Trigeminal Neuralgia Dato' Dr Jagdeep Nanra Malaysia",
      },
      {
        id: 'K1',
        category: "MINIMALLY INVASIVE / ENDOSCOPIC NEURSOURGERY",
        topic: "Evolution in Modern Neuroendoscopy : Local Perspectives and Step into the Future",
        speaker: "YBrs. Dr. Azmi Alias",
        country: "Malaysia",
        link: "https://player.vimeo.com/video/557584889",
        form: "azmidr@hotmail.com",
        thumbnail: slide37,
        title: "MINIMALLY INVASIVE / ENDOSCOPIC NEURSOURGERY Evolution in Modern Neuroendoscopy : Local Perspectives and Step into the Future YBrs. Dr. Azmi Alias Malaysia",
      },
      {
        id: 'K2',
        category: "MINIMALLY INVASIVE / ENDOSCOPIC NEURSOURGERY",
        topic: "Pituitary Tumor with High Ki67 Index: Treatment Options and Dilemma",
        speaker: "Dr Donald Liew",
        country: "Malaysia",
        link: "https://player.vimeo.com/video/557261014",
        form: "donnsliew@gmail.com",
        thumbnail: slide38,
        title: "MINIMALLY INVASIVE / ENDOSCOPIC NEURSOURGERY Pituitary Tumor with High Ki67 Index: Treatment Options and Dilemma Dr Donald Liew Malaysia",
      },
      {
        id: 'K3',
        category: "MINIMALLY INVASIVE / ENDOSCOPIC NEURSOURGERY",
        topic: "Endoscopic Endonasal Surgery for Paediatric Craniopharyngiomas: Can We Prevent Postoperative Obesity?",
        speaker: "Dr Hiroshi Nishioka",
        country: "Japan",
        link: "https://player.vimeo.com/video/557260973",
        form: "nishioka@tokyo-med.ac.jp",
        thumbnail: slide39,
        title: "MINIMALLY INVASIVE / ENDOSCOPIC NEURSOURGERY Endoscopic Endonasal Surgery for Paediatric Craniopharyngiomas: Can We Prevent Postoperative Obesity? Dr Hiroshi Nishioka Japan",
      },
      // {
      //   id: 'K4',
      //   category: "MINIMALLY INVASIVE / ENDOSCOPIC NEURSOURGERY",
      //   topic: "PENDING",
      //   speaker: "Dr José Antonio Soriano Sánchez",
      //   country: "Mexico",
      //   link: "",
      //   form: "neurojass@hotmail.com",
      //   thumbnail: slide40,
      //   title: "MINIMALLY INVASIVE / ENDOSCOPIC NEURSOURGERY PENDING Dr José Antonio Soriano Sánchez Mexico",
      // },
      {
        id: 'L1',
        category: "WOMEN IN NEUROSURGERY",
        topic: "Inspiring Journey of the First Woman Neurosurgeon in South-East Asia",
        speaker: "Dr. Camellia Posoncuy",
        country: "Philippines",
        link: "https://player.vimeo.com/video/557566473",
        form: "sc_theo3@yahoo.com",
        thumbnail: slide41,
        title: "WOMEN IN NEUROSURGERY Inspiring Journey of the First Woman Neurosurgeon in South-East Asia Dr. Camellia Posoncuy Philippines",
      },
      {
        id: 'L2',
        category: "WOMEN IN NEUROSURGERY",
        topic: "Minimal Access Spine Surgery For The Neurosurgeon",
        speaker: "Dr Ibet Marie Y. Sih",
        country: "Philippines",
        link: "https://player.vimeo.com/video/557253832",
        form: "ibetsih@yahoo.com",
        thumbnail: slide42,
        title: "WOMEN IN NEUROSURGERY Minimal Access Spine Surgery For The Neurosurgeon Dr Ibet Marie Y. Sih Philippines",
      },
      {
        id: 'L3',
        category: "WOMEN IN NEUROSURGERY",
        topic: 'Is It A New Culprit ? "Tert Promoter Mutation" In An Aggressive Pediatric Pilocytic Astrocytoma',
        speaker: "Dr Jacintha Vikeneswary Francis",
        country: "Malaysia",
        link: "https://player.vimeo.com/video/557253873",
        form: "jacinthavf@gmail.com",
        thumbnail: slide43,
        title: 'WOMEN IN NEUROSURGERY Is It A New Culprit ? "Tert Promoter Mutation" In An Aggressive Pediatric Pilocytic Astrocytoma Dr Jacintha Vikeneswary Francis Malaysia',
      },
      {
        id: 'L4',
        category: "WOMEN IN NEUROSURGERY",
        topic: "Indonesian Women Neurosurgeon: Now and Then, and the Brighter Future",
        speaker: "Dr. Mirna Sobana",
        country: "Indonesia",
        link: "https://player.vimeo.com/video/557252974",
        form: "mirna.sobana@unpad.ac.id",
        thumbnail: slide44,
        title: "WOMEN IN NEUROSURGERY Indonesian Women Neurosurgeon: Now and Then, and the Brighter Future Dr. Mirna Sobana Indonesia",
      },
      {
        id: 'L6',
        category: "WOMEN IN NEUROSURGERY",
        topic: "Building Multidisciplinary team in managing pituitary tumor in developing country",
        speaker: "Dr Selfy Oswari",
        country: "Indonesia",
        link: "https://player.vimeo.com/video/558873027",
        form: "oswari.selfy@gmail.com",
        thumbnail: slide46,
        title: "WOMEN IN NEUROSURGERY Building Multidisciplinary team in managing pituitary tumor in developing country Dr Selfy Oswari Indonesia",
      },
      {
        id: 'L7',
        category: "WOMEN IN NEUROSURGERY",
        topic: "The Neurosurgery Journey - Reflections as an Exiting Resident",
        speaker: "Dr Swathi Jain",
        country: "Singapore",
        link: "https://player.vimeo.com/video/557566413",
        form: "swati.jain@mohh.com.sg",
        thumbnail: slide47,
        title: "WOMEN IN NEUROSURGERY The Neurosurgery Journey - Reflections as an Exiting Resident Dr Swathi Jain Singapore",
      },
      {
        id: 'L8',
        category: "WOMEN IN NEUROSURGERY",
        topic: "Paediatrics and Women in Neurosurgery",
        speaker: "Dr Sharon Low Yin Yee",
        country: "Singapore",
        link: "https://player.vimeo.com/video/558483651",
        form: "sharon.low.y.y@singhealth.com.sg",
        thumbnail: slide48,
        title: "WOMEN IN NEUROSURGERY Paediatrics and Women in Neurosurgery Dr Sharon Low Yin Yee Singapore",
      },
      {
        id: 'L5',
        category: "WOMEN IN NEUROSURGERY",
        topic: "Stroke Code Application in Indonesia",
        speaker: "Dr.Nurullah Armyta Tasrif",
        country: "Indonesia",
        link: "https://player.vimeo.com/video/559362684",
        form: "nuya.tasrif@gmail.com",
        thumbnail: slide45,
        title: "WOMEN IN NEUROSURGERY Stroke Code Application in Indonesia Dr.Nurullah Armyta Tasrif Indonesia",
      },
    ]
  },
  {
    name: "Satellite Symposium",
    thumbnail: cat2,
    destination: "/on-demand/satellite-symposium",
    videos: [
      {
        topic: "Diffusion Tractography - How it allows neurosurgeons to better manage their surgical approach and resection",
        link: "",
        form: "https://media.brainlab.com/embed/lEvNRqQ-en",
        thumbnail: satelite1,
        title: "BRAINLAB Diffusion Tractography - How it allows neurosurgeons to better manage their surgical approach and resection",
      },
      {
        topic: "Navigated Ultrasound In Neurosurgery Ask The Experts",
        link: "",
        form: "https://media.brainlab.com/embed/gJxbTwx-en",
        thumbnail: satelite2,
        title: "BRAINLAB Navigated Ultrasound In Neurosurgery Ask The Experts",
      },
      {
        topic: "Clinical Experience in using IORT during neuro treatments for brain and spine metastases and GBM",
        link: "https://player.vimeo.com/video/558037136",
        form: "",
        thumbnail: satelite3,
        title: "ZEISS Clinical Experience in using IORT during neuro treatments for brain and spine metastases and GBM",
      },
      {
        topic: "Fluorescence In Brain Tumors",
        link: "https://player.vimeo.com/video/558037312",
        form: "",
        thumbnail: satelite4,
        title: "ZEISS Fluorescence In Brain Tumors",
      },
    ]
  },
  {
    name: "Virtual Product Theatre",
    thumbnail: cat3,
    destination: "/on-demand/virtual-product-theatre",
    videos: [
      {
        topic: "Elements Radiosurgery For Multiple Brainmets",
        link: "https://player.vimeo.com/video/558038514",
        form: "",
        thumbnail: virtual1,
        title: "BRAINLAB Elements Radiosurgery For Multiple Brainmets",
      },
      {
        topic: "Ultrasound Navigation",
        link: "https://player.vimeo.com/video/558038665",
        form: "",
        thumbnail: virtual2,
        title: "BRAINLAB Ultrasound Navigation",
      },
      {
        topic: "Workflow Microscope Navigation",
        link: "https://player.vimeo.com/video/558038749",
        form: "",
        thumbnail: virtual3,
        title: "BRAINLAB Workflow Microscope Navigation",
      },
      {
        topic: "Medical Technology Virtual Experience",
        link: "",
        form: "https://med-showroom.zeiss.com/mcs/neuro/showroom",
        thumbnail: virtual4,
        title: "ZEISS Medical Technology Virtual Experience",
      },
    ]
  },
]

const masterClass = [
  {
    id: 1,
    topic: "Cerebral AVM – Treatment Options & Impact of ARUBA",
    speaker: "Dr Azman Raffiq (Chairman)",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/557214562",
    form: "denshum77@yahoo.com",
    thumbnail: master1,
    title: "Cerebral AVM – Treatment Options & Impact of ARUBA Dr Azman Raffiq (Chairman) Malaysia",
  },
  {
    id: 2,
    topic: "Endoscopic Third Ventriculostomy",
    speaker: "Dr Asma’ Afifi",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/557602254",
    form: "asmaafifi@gmail.com",
    thumbnail: master2,
    title: "Endoscopic Third Ventriculostomy Dr Asma’ Afifi Malaysia",
  },
  {
    id: 3,
    topic: "Pterional Approach to Craniopharyngioma",
    speaker: "Dr Ch'ng Chee How & Dr Ihfaz Ismail",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/557249584",
    form: "cheehow2000@yahoo.com",
    thumbnail: master3,
    title: "Pterional Approach to Craniopharyngioma Dr Ch'ng Chee How & Dr Ihfaz Ismail Malaysia",
  },
  {
    id: 4,
    topic: "Meckel's Cave Vs Petrous Apex Epidermoid Technical Considerations In Approach Selection",
    speaker: "Dr Donald Liew Ngian San",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/557240877",
    form: "donnsliew@gmail.com",
    thumbnail: master4,
    title: "Meckel's Cave Vs Petrous Apex Epidermoid Technical Considerations In Approach Selection Dr Donald Liew Ngian San Malaysia",
  },
  {
    id: 5,
    topic: "An Overview Of Gamma Knife (GK) Treatment",
    speaker: "Assoc Prof Dr Farizal Fadzil",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/557214488",
    form: " nurelisha@yahoo.com",
    thumbnail: master5,
    title: "An Overview Of Gamma Knife (GK) Treatment Assoc Prof Dr Farizal Fadzil Malaysia",
  },
  {
    id: 6,
    topic: "Percutaneous Pedicle Screw",
    speaker: "Dr Gee Teak Sheng",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/557214740",
    form: "teaksheng@gmail.com",
    thumbnail: master6,
    title: "Percutaneous Pedicle Screw Dr Gee Teak Sheng Malaysia",
  },
  {
    id: 7,
    topic: "Diffuse Tensor Imaging and Fiber Tractography in Cranial Nerves Surgery",
    speaker: "Dr Lim Swee San",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/557214335",
    form: "sweesan79@gmail.com",
    thumbnail: master7,
    title: "Diffuse Tensor Imaging and Fiber Tractography in Cranial Nerves Surgery Dr Lim Swee San Malaysia",
  },
  {
    id: 8,
    topic: "Treating Cases Of Large Myelomeningocele In Small Neurosurgical Centre: Our Experience",
    speaker: "Dr Nujaimin Udin",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/557997058",
    form: "drnujaimin@moh.gov.my",
    thumbnail: master8,
    title: "Treating Cases Of Large Myelomeningocele In Small Neurosurgical Centre: Our Experience Dr Nujaimin Udin Malaysia",
  },
  {
    id: 9,
    topic: "Lumbar Pain Intervention Techniques for Beginners",
    speaker: "Dr Raffiz Mohd Ali",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/557237014",
    form: "raffiz_dr@yahoo.co.uk",
    thumbnail: master9,
    title: "Lumbar Pain Intervention Techniques for Beginners Dr Raffiz Mohd Ali Malaysia",
  },
  {
    id: 10,
    topic: "Surgical Management Of Thoracic Dumbbell Spinal Schwannoma",
    speaker: "Dr. R. Senthil Kumar & Dr. Kelvin Lim Liang Hooi",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/557214409",
    form: "senthilkraj80@gmail.com",
    thumbnail: master10,
    title: "Surgical Management Of Thoracic Dumbbell Spinal Schwannoma Dr. R. Senthil Kumar & Dr. Kelvin Lim Liang Hooi Malaysia",
  },
  {
    id: 11,
    topic: "Principles Of Aneurysm Clips",
    speaker: "Dr Sharon Casilda Theophilus",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/557792079",
    form: "sc_theo3@yahoo.com",
    thumbnail: master11,
    title: "Principles Of Aneurysm Clips Dr Sharon Casilda Theophilus Malaysia",
  },
  {
    id: 12,
    topic: "Orbito-Zygomatic Craniotomy (COZ) Approach",
    speaker: "Dr Rakesh Rethinasamy",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/557996787",
    form: "rakesh_r3@hotmail.com",
    thumbnail: master12,
    title: "Orbito-Zygomatic Craniotomy (COZ) Approach Dr Rakesh Rethinasamy Malaysia",
  },
  {
    id: 13,
    topic: "Endoscopic Antomy of 3rd Ventricle Floor - Technical Nuances",
    speaker: "Dr Mohd Aidil Mohd Nor",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/558555651",
    form: "aidil@moh.gov.my",
    thumbnail: master13,
    title: "Endoscopic Antomy of 3rd Ventricle Floor - Technical Nuances Dr Mohd Aidil Mohd Nor Malaysia",
  },
  {
    id: 14,
    topic: "Covid 19 pandemic and its challenges in small Neurosurgical center",
    speaker: "Dr Lai Chuang Chee",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/558481060",
    form: "chuangchee@hotmail.com",
    thumbnail: master14,
    title: "Covid 19 pandemic and its challenges in small Neurosurgical center Dr Lai Chuang Chee Malaysia",
  },
  {
    id: 15,
    topic: "Case Series Cerebral Cavernoma",
    speaker: "Dr Neoh Yee Yik",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/558481139",
    form: "drneohyeeyikneuro@gmail.com",
    thumbnail: master15,
    title: "Case Series Cerebral Cavernoma Dr Neoh Yee Yik Malaysia",
  },
  {
    id: 16,
    topic: "Breaking The Bad News In Neorosurgery",
    speaker: "Dato Dr Nasser Abdul Wahab",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/558549641",
    form: "nasserdr@msn.com",
    thumbnail: master16,
    title: "Breaking The Bad News In Neorosurgery Dato Dr Nasser Abdul Wahab Malaysia",
  },
  {
    id: 17,
    topic: "Minimally Invasive Neurosurgery : Mini Petrional Craniotomy",
    speaker: "Dr Mohd Sofan Zenian",
    country: "Malaysia",
    link: "https://player.vimeo.com/video/559367851",
    form: "msofanz@hotmail.com",
    thumbnail: master17,
    title: "Minimally Invasive Neurosurgery : Mini Petrional Craniotomy Dr Mohd Sofan Zenian Malaysia",
  },
]
 
const categories = [
  "NEURO-ONCOLOGY",
  "SPINE / PERIPHERAL NERVE",
  "TECHNOLOGICAL ADVANCMENTS IN NEUROSURGERY",
  "SKULL BASE",
  "VASCULAR",
  "PAEDIATRICS",
  "FUTURE OF EDUCATION AND PERSPECTIVE ON WORLD NEUROSURGERY",
  "TRAUMA",
  "EPILEPSY",
  "RADIOSURGERY",
  "MINIMALLY INVASIVE / ENDOSCOPIC NEURSOURGERY",
  "WOMEN IN NEUROSURGERY",
]

export { onDemand, masterClass, categories}